import { VehicleType } from "@busbud/int-schemas/lib/vehicles";

import { getBaseUrl } from "@app/components/search-form-hydrated/autocomplete-input-hydrated/hooks/use-search-widget-state";
import type { AffiliatePartners } from "@app/constants/affiliate-partners";
import type { VehicleCategoryKey } from "@app/modules/results/state/filters-types";
import {
  getResultsPageUrl,
  getSearchAffiliateQuery
} from "@app/modules/search/helpers/submit";
import { redirectToAffiliatePartner } from "@app/tracking/search-tracking";
import type { AmplitudeGtmTracker } from "@app/tracking/tracker";
import type { Features } from "@app/types/experiments";
import type { PublicInterface } from "@app/types/meta-types";
import type { SearchFormMergedState } from "@app/types/search-types";
import { openAndFocusOn, redirect } from "@app/utils/window";

import { landing_pages_entities_trains_types } from "@data/entity-types";

import type { SupportedLocale } from "@config/locales";

interface ResultsPageRedirectOptions {
  locale: SupportedLocale;
  features: Partial<Features>;
  state: Omit<SearchFormMergedState, "passengers">;
  whitelabel: string | undefined;
  tracker: PublicInterface<AmplitudeGtmTracker> | null;
  user_country_code: string | null;
}

export const openToResultsPage = ({
  state,
  ...options
}: ResultsPageRedirectOptions): void => {
  const results_page_url = getResultsPageUrl(options, state);
  openAndFocusOn(results_page_url);
};

const getVehicleCategory = (
  state_vehicle_category: VehicleCategoryKey | undefined
): VehicleCategoryKey | undefined => {
  const global_entity_type = window.BB.entity?.type;
  const is_train_entity: boolean =
    !!global_entity_type &&
    landing_pages_entities_trains_types.includes(global_entity_type);
  return is_train_entity ? VehicleType.Train : state_vehicle_category;
};

export const redirectToResultsPage = (
  options: ResultsPageRedirectOptions
): void => {
  const vehicle_category = getVehicleCategory(options.state.vehicle_category);

  const results_page_url = getResultsPageUrl(options, {
    ...options.state,
    vehicle_category
  });
  redirect(results_page_url);
};

export const redirectWebComponentToResultsPage = (
  options: ResultsPageRedirectOptions
): void => {
  const results_page_url = getResultsPageUrl(options, options.state);
  const base_url = getBaseUrl();
  window.location.href = `${base_url}${results_page_url}`;
};

export const ancillaryRedirectAffiliateAndShowBusbudResults = (
  affiliate_name: AffiliatePartners,
  options: ResultsPageRedirectOptions
): void => {
  const { state, tracker } = options;

  // open new window for busbud on focus
  try {
    const url = getSearchAffiliateQuery({
      ...state,
      user_country_code: options.user_country_code,
      affiliate_name
    });
    tracker?.track(
      redirectToAffiliatePartner(affiliate_name, "searchbox_pop_under")
    );
    openToResultsPage(options);
    redirect(url);
  } catch {
    redirectToResultsPage(options);
  }
};
